import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import changeTrackable, { IChangeTrackable } from './changeTrackable';
import model from './model';

export interface IInstallSheet extends IModel, IChangeTrackable {
	margin?: number;
	name?: string;
	sortIndex?: number;
	unitCost?: number;
}

const installSheetFactory = modelFactory.createFactory<IInstallSheet>('InstallSheet', _.assign({}, model, changeTrackable, {
	margin: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: validator.number(),
		defaultValue: 0.0
	},
	name: {
		setFilters: valueFilters.toString,
		rules: validator.string(false)
	},
	sortIndex: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: validator.number(),
		defaultValue: 0.0
	},
	unitCost: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: validator.number(),
		defaultValue: 0.0
	}
}));

export default installSheetFactory;